/**
* In Physician function is used to list the Physician details and its functions declare this file
**/
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ApiService from '../../services/ApiService';
import Pagination from '../../shared/components/Pagination';
import { goBack, convertS3privateToPublic } from '../../services/UtilsService';
import { toast } from 'react-toastify';
import DeleteModal from '../../shared/modals/DeleteModal';
import { useTranslation } from 'react-i18next';

function Physician(props) {
    //Intial state declaration
    const [physicianList, setPhysicianList] = useState([]);
    const [param, setParam] = useState({ page: 0, limit: 10 });
    const [modal, setModal] = useState({});
    const role = Number(localStorage.getItem('role'));
    const { t } = useTranslation();
    //const [users, setUser] = useState({});

    /** 
    * To handle search functions
    * @e - we get the event details from the change action
    **/
    const handleChange = async (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setParam({ ...param, [name]: value, page: 0 });
    };

    /** 
    * To handle Sort functions
    * @e - we get the event details from the change action
    **/
    const handleSortChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setParam({ ...param, [name]: value });
    };

    /**
   * To delete physician functions 
   * @event - we  pass the value and id 
   * id - pass the particular physician id
   * value - pass the boolean value
   **/
    const handleDelete = async (event) => {
        const { value, id } = event;
        var data = {};
        data.accountId = id;

        if (value) {
            await setModal({ ...modal, delete: !value })
            const response = await ApiService.deletePhysicianList(id);
            if (response.status === 200) {
                toast.success(response?.data?.message);
                setModal({ ...modal, value: value, modal: 'success' })
                setParam({ page: 0, limit: 10 })
            } else {
                toast.error(response?.data?.message);
            }
        }
    }

    /** 
    * To handle pagination event
    * @data - we pass the page number
    **/
    const handlePaginate = (data) => {
        setParam({ ...param, page: data });
    };


    //components initialize function and api handling
    useEffect(() => {
        (async () => {
          try {
            // Fetch the physician list
            const response = await ApiService.physicianList(param);
            console.log("Response Data from physicianList:", response.data);
      
            // Fetch users list with hospital and physician
            const userResponse = await ApiService.getUsersList({ list: ["hospital", "physician"] });
            console.log("Original Physician List : ", response.data);
      
            if (userResponse.status === 200) {
              const { hospital = [], physician = [] } = userResponse.data;
              const userRole = localStorage.getItem("role"); // Retrieve role from localStorage or context
              console.log("Role : ", userRole);
      
              let allowedHospitalId = null;
      
              // Check role and extract the hospital ID
              if (parseInt(userRole) === 4 && hospital.length > 0) {
                allowedHospitalId = hospital[0]?.id; // Get the first hospital ID (modify as needed for multiple hospitals)
                console.log("Allowed Hospital ID : ", allowedHospitalId);
              }
      
              // Filter `filteredPhysicians` based on the hospital condition
              const filteredPhysicians = physician.filter(
                (physicianItem) =>
                  !physicianItem.hospital || // Allow if hospital is empty or null
                  physicianItem.hospital === allowedHospitalId // Allow if hospital matches the allowed hospital ID
              );
              console.log("Filtered Physicians:", filteredPhysicians);
      
              // Extract the accounts from `filteredPhysicians`
              const allowedAccounts = filteredPhysicians.map((item) => item.account);
      
              // Ensure `response.data.details` is accessed as the physician list
              const physicianList = Array.isArray(response.data.details) ? response.data.details : [];
              console.log("Processed Physician List:", physicianList);
      
              // Filter `physicianList` for role 4
              if (parseInt(userRole) === 4) {
                const updatedPhysicianList = physicianList.filter(
                  (physicianItem) =>
                    allowedAccounts.includes(physicianItem.account) && // Account must be present in both
                    (!physicianItem.hospital || // Hospital is empty/null
                      physicianItem.hospital.trim() === "" || // Hospital is empty string
                      physicianItem.hospital === allowedHospitalId) // Hospital matches allowedHospitalId
                );

                 // Include count and message along with the filtered physician details
                const updatedPhysicianListWithMeta = {
                    details: updatedPhysicianList,
                    counts: updatedPhysicianList.length.toString(), // Set the count based on the filtered list
                    message: response.data.message, // Include the original message
                };
      
                // Update the state with the filtered data
                //setUser({ ...userResponse.data, physician: filteredPhysicians });
                setPhysicianList(updatedPhysicianListWithMeta);
                console.log("Mapped and Filtered Physician List : ", updatedPhysicianListWithMeta);
                return; // Stop execution for role 4 after setting state
              }
            }
      
            // For other roles, set the physician list as is
            setPhysicianList(response.data);
          } catch (error) {
            console.error("Error fetching user or physician list:", error);
          }
        })();
      }, [param]);
      
      
      
      
            

    //To close modal
    const handleClose = () => setModal({});


    return (
        <main id={props.data === 'dashboard' && role === 4 ? '' : 'main'} className="main">

            {/*Import DeleteModal*/}
            {Object.keys(modal).length !== 0 && modal.delete && <DeleteModal data={modal} handleDelete={handleDelete} handleClose={handleClose} />}
            {/*Page Title Section*/}
            {props.data !== 'dashboard' && (
            <div className="pagetitle clearfix">
                <div className="float-start">
                    <h1>{t('sidebar.physician')}</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to={window.location.href.includes('hospital') ? "/hospital/admin/dashboard" : "/admin/dashboard"}>{t('sidebar.home')}</Link></li>
                            <li className="breadcrumb-item active">{t('sidebar.physician')} </li>
                        </ol>
                    </nav>
                </div>
                <div className="float-end mt-2 me-1">
                    <span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
                </div>
            </div>
            )}
            {/*End Page Title Section*/}

            {/* Page Content Section */}
            <section className="pagesection">
                <div className="row my-3">
                    {/*Search*/}
                    <div className="col-xxl-6 col-lg-6 d-flex">
                        <div className="input-group input-group-sm me-2 w-50">
                            <input type="text" name="search" value={param.search ? param.search : ''}
                                onChange={handleChange} className="form-control" placeholder={t('common.search')} />
                            <button className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'}`} type="button"><i className="ri-search-line"></i></button>
                        </div>
                    </div>
                    {/*End Search*/}
                    <div className="col-xxl-6 col-lg-6">
                        { props.data !== 'dashboard' && (
                        <Link to={window.location.href.includes('hospital') ? "/hospital/admin/add-physician" : "/admin/add-physician"} className={`btn btn-sm ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} float-end`}>
                            <i className="iconly-Bold-Plus align-middle me-1"></i> {t('common.addPhysician')}
                        </Link>
                        )}

                        {role === 4 && props.data === 'dashboard' && (
                        <Link to={'/hospital/admin/physician'}>
                            <button type="button" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'} float-end`}>
                                <i className="ri-file-list-line  align-middle"></i> View All
                            </button>
                        </Link>
                        )}
                        {/*Sort*/}
                        <div className="dropdown float-end me-3">
                            <a className={`btn btn-sm ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'} dropdown-toggle`} href="javascript;" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"> {t('common.sort')} </a>

                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <li>
                                    <button className={param.sort === 'added' ? `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''} active` : `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''}`} type="button" value="added" name="sort" onClick={handleSortChange} > {t('common.newlyAdded')} </button>
                                </li>
                                <li>
                                    <button className={param.sort === 'a-z' ? `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''} active` : `dropdown-item ${role === 4 ? 'admin-dropdown-item' : ''}`} type="button" value="a-z" name="sort" onClick={handleSortChange} > {t('common.alphabeticalOrder')} </button>
                                </li>
                            </ul>
                        </div>
                        {/*End Sort*/}
                    </div>
                </div>
                {/*Table*/}
                <div className="row my-3">
                    <div className="col-xxl-12">
                        <div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`}>
                            <table className="table table-borderless theme-table">
                                <thead>
                                    <tr>
                                        <th scope="col">{t('profile.physicianName')}</th>
                                        <th scope="col">{t('table.contactNumber')}</th>
                                        <th scope="col">{t('profile.emailAddress')}</th>
                                        <th scope="col">{t('profile.location')}</th>
                                        <th scope="col" className="text-center">{t('profile.action')}</th>
                                    </tr>
                                </thead>
                                {physicianList && physicianList?.details?.length ? (
                                    <tbody>
                                        {physicianList && physicianList.details && physicianList.details.map((item, i) => (
                                            <tr key={i}>
                                                <td >
                                                    <Link to={window.location.href.includes('hospital')
													? `/hospital/admin/view-physician/${item.account}`
													: `/admin/physician/${item.account}`}>
                                                        <div className="d-flex align-items-center ps-1">
                                                            <div className="avtar-img">
                                                                <span className="rounded-circle">
                                                                    {item?.photo === 'default.png' ? <img src="/assets/img/user-avatar.png" alt="UN" /> : <img src={convertS3privateToPublic(item?.photo)} alt="UN" />}
                                                                </span>
                                                            </div>
                                                            <div className="ms-2">
                                                                <h5 className="table-title text-capitalize">{item?.first_name + ' ' + item?.last_name}</h5>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{item?.mobileNumber ?
                                                    item?.countryCode + ' ' + item?.mobileNumber : '--'}</td>
                                                <td><a href={`mailto:${item?.email}`}>{item?.email}</a></td>
                                                <td className="text-capitalize">
                                                    {item.city ? item.city + ',' : ''}
                                                    {item.state ? item.state : ''}
                                                    {!(item.city || item.state) ? '--' : ''}
                                                </td>
                                                <td className="text-center fw-normal">
                                                    <Link
                                                        to={window.location.href.includes('hospital')
                                                            ? `/hospital/admin/edit-physician/${item.account}`
                                                            : `/admin/edit-physician/${item.account}`}
                                                        className="text-warning d-inline"
                                                        onClick={() => {
                                                            if (item?.created_by) {
                                                                console.log("ITEM : ",item);
                                                                localStorage.setItem('created_by', item.created_by);
                                                            }
                                                        }}
                                                    ><i className="iconly-Bold-Edit align-middle me-2"></i></Link>
                                                    <Link onClick={() => setModal({ delete: true, id: item?.account })} className="text-danger d-inline"><i className="iconly-Bold-Delete align-middle"></i></Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr>
                                            <td colSpan="7" className="text-center">{t('common.noRecord')}</td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
                {/*End Table*/}

                {/*Pagination*/}
                {physicianList && physicianList.length !== 0 && physicianList?.details?.length !== 0 && <div className="row my-3">
                    <div className="col-xxl-12 d-flex justify-content-center">
                        <Pagination page={param.page} handlePaginate={handlePaginate} total={physicianList.counts} />
                    </div>
                </div>}
                {/*End Pagination*/}
            </section>
            {/* End Page Content Section */}

        </main>
    );
}

export default Physician;
